module.exports = __webpack_public_path__ + "img/beeldschermbril-nek.9414847a.svg";